<template>
 <div id="capitalDeposit-view">
   <div class="content">
     <div class="main-title">
        <h1>“交易资金全程接入新网银行存管系统”</h1>
        <div></div>
     </div>
     <div class="img-item">
       <img src="../../assets/images/newsarftyicon3.png" alt="">
     </div>
     <autograph></autograph>
   </div>
 </div>
</template>

<script>
import autograph from '@/components/autograph'
export default {
  data () {
    return {

    }
  },
  mounted () {
    this.verifyLogin().then((res) => {}).catch(() => {})
  },
  components: {
    autograph
  }
}
</script>

<style lang="less">
#capitalDeposit-view{
  background: #f5f5f5;
  padding-bottom: 20px;
  .content{
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    .main-title{
      width: 500px;
      height: 135px;
      margin:0 auto;
      text-align: center;
      padding-top:100px;
      >h1{
        font-size: 24px;
        font-weight: 400;
        margin-bottom:10px;
      }
      div{
        width: 27px;
        height: 6px;
        margin:20px auto;
        background: #ff4932;
        box-shadow: 2px 2px 2px #f8b8b0;
      }
    }
    .img-item{
      width: 760px;
      margin: 0 auto;
      margin-bottom: 150px;
      img{
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/riskControl/capitalDeposit.vue